import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label} from 'recharts';
import React, {useMemo, useState} from "react";
import styles from "./UserChart.module.scss";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";

const UserChart = (props) => {
    const {
        data,
    } = props;

    const [filterStartDate, setFilterStartDate] = useState();
    const [filterEndDate, setFilterEndDate] = useState();

    const filteredData = useMemo(() => {
        if (!filterStartDate && !filterEndDate) return data;

        return data.filter(row => {
            if (filterStartDate) {
                const rowDate = moment(row.date);
                if (rowDate.isBefore(filterStartDate)) return false;
            }
            if (filterEndDate) {
                const rowDate = moment(row.date);
                if (rowDate.isAfter(filterEndDate)) return false;
            }
            return true;
        });
    }, [filterStartDate, filterEndDate]);

    if (!data) return <LoadingSpinner local />;

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                    value={filterStartDate}
                    onChange={(value) => setFilterStartDate(value)}
                    label="Filter Start Date"/>
                <DateTimePicker
                    value={filterEndDate}
                    onChange={(value) => setFilterEndDate(value)}
                    label="Filter End Date"/>
            </LocalizationProvider>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="Users Per Day" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="KYC Approved Per Day" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="Total Users" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <div className={styles.chartContainer}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        width={500}
                        height={300}
                        data={filteredData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date">
                            <Label value="Date" offset={0} position="insideBottom"/>
                        </XAxis>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>
                        <Line type="monotone" dataKey="Total KYC Approved" stroke="#82ca9d" activeDot={{r: 8}}>

                        </Line>
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default UserChart;
